import { atomWithStorage } from "jotai/utils";

import { Org } from "~/utils/Types";

const initialValue = undefined;

export const orgsAtom = atomWithStorage<Org[] | undefined>(
  "orgs",
  initialValue,
  undefined,
  { getOnInit: true },
);
